import type { PageLoad } from './$types';
import { pocketbase } from "$lib/pocketbase"
import { error } from "@sveltejs/kit"

export const load = (async () => {
  try {
    const settings = await pocketbase.collection("platform_settings").getFullList()
    return {
      settings
    }
  } catch (e) {
    console.error(e)
    throw error(404, "Could not find settings")
  }

}) satisfies PageLoad;